import React, { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import People from '@src/pc/index/layout/Page1/People';
import Chip from 'Chip';

const Page1 = (props) => {
    const { peopleList, leaderVideo, onChangeMaskVisible, onChangeCurrentVideo, onChangeFloat, config } = props;
    const [peopleIndex, setPeopleIndex] = useState(-1);
    const [isShowHUD, setIsShowHUD] = useState(false);

    const swiperRef = useRef();
    const maskRef = useRef();
    const lightRef = useRef();

    const changePeopleAndSwiper = (index) => {
        setPeopleIndex(index);
        // eslint-disable-next-line no-unused-expressions
        swiperRef.current?.slideTo(index + 1);
    };

    const toPrev = () => {
        changePeopleAndSwiper(peopleIndex - 1);
    };

    const toNext = () => {
        if (peopleIndex < peopleList.length - 1) {
            changePeopleAndSwiper(peopleIndex + 1);
        }
    };

    const openVideo = () => {
        onChangeCurrentVideo({
            url: leaderVideo.videoUrl,
            guid: leaderVideo.videoGuid,
            duration: leaderVideo.videoDuration,
        });
        onChangeMaskVisible(true);
    };

    const ChangeAnimate = useCallback((node) => {
        if (node) {
            // setTimeout(() => {
            //     node.classList.add(Style.part2);
            //     setTimeout(() => {
            //         setIsShowHUD(true);
            //         onChangeFloat(true);
            //         node.classList.add(Style.part3);
            //         maskRef.current.classList.add(Style.part3_mask);
            //         setTimeout(() => {
            //             lightRef.current.classList.add(Style.lightShow);
            //             setTimeout(() => {
            //                 changePeopleAndSwiper(1);
            //             }, 1000);
            //         }, 600);
            //     }, 800);
            // }, 1020);
        }
    }, []);

    return (
        <div className={Style.page1}>
            <img className={`${Style.logo} ${Style.show}`} src={require('@src/common/assets/logo.png')} alt="" />
            <img className={Style.swiper} src={require('@src/common/assets/first.png')} alt="" />
        </div>
    );
};

Page1.propTypes = {
    peopleList: PropTypes.array,
    config: PropTypes.array,
    leaderVideo: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    onChangeFloat: PropTypes.func,
};

export default errorBoundary(Page1);
